import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PreflopTable from '../../components/tables/preflop/PreflopTable';
import { useGame } from '../../context/GameContext';

export const PreflopView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { startNewGame, gameState } = useGame();

  // If we have a config in the location state, start a new game
  React.useEffect(() => {
    if (location.state?.config) {
      startNewGame(location.state.config);
    }
  }, [location.state, startNewGame]);

  // If no game state, redirect to config
  if (!gameState?.gameConfig) {
    navigate('/quiz-config');
    return null;
  }

  return <PreflopTable />;
};